import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useSeo } from "../../lib/seo";
import { useT } from "../../lib/i18n";

export function Confirmation() {
  const { state } = useLocation();
  const { t } = useT();
  useSeo({ title: t("Demande envoyée"), path: "/demande/confirmation", noindex: true });
  if (!state?.ref) return <Navigate to="/" replace />;
  return (
    <section className="k-section pt-16 max-w-3xl" data-testid="confirmation">
      <CheckCircle2 className="text-[#C25E38]" size={40} />
      <p className="k-eyebrow mt-6">{t("Demande de devis reçue")}</p>
      <h1 className="k-h1 mt-4">{t("Merci. Votre dossier")} <span className="text-[#C25E38]" data-testid="confirmation-ref">{state.ref}</span> {t("est ouvert.")}</h1>
      <p className="k-lead mt-4">{t("Un email de confirmation contenant un lien sécurisé vers votre dossier a été envoyé à")} <strong>{state.email}</strong>. {t("Un membre de l'atelier vous rappelle pour préciser votre projet, puis vous envoie votre devis. Pensez à vérifier vos courriers indésirables.")}</p>
      {state.missing?.length > 0 && (
        <div className="mt-8 border-l-2 border-[#C25E38] pl-5" data-testid="confirmation-missing">
          <p className="font-medium">{t("Nous préciserons ensemble :")}</p>
          <ul className="text-sm text-[#57534E] mt-2 list-disc pl-5">{state.missing.map((m) => <li key={m}>{t(m)}</li>)}</ul>
        </div>
      )}
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/" className="k-btn-outline" data-testid="confirmation-home">{t("Retour à l'accueil")}</Link>
        <Link to="/espace-client" className="k-link self-center text-sm" data-testid="confirmation-client-link">{t("Accéder à mon dossier")}</Link>
      </div>
    </section>
  );
}
